import getById from 'utils/DOM/getById'
import getTemplate from 'utils/DOM/getTemplate'
import innerHTML from 'utils/DOM/innerHTML'
import toggleClass from 'utils/DOM/toggleClass'
import { getExternalPartnerUrl } from 'core/services/getExternalPartnerUrl'
import { FLEX_BENEFITS } from 'core/constants/products'

const additionalProductsWrap = getById('additional-products-wrap')
const partnerTileTemplate = getTemplate('partner-tile-template')

const getUrlAndRedirect = partner =>
  getExternalPartnerUrl({
    agentId: partner.agentId,
    partnerId: partner.partnerId
  }).then(response => {
    if (response) window.open(response.partnerUrl, '_blank')
  })

export default function render({ externalPartners }) {
  toggleClass(additionalProductsWrap, 'd-none', false)
  // Render HTML for each external partner
  innerHTML(
    additionalProductsWrap,
    externalPartners.filter(p => p.partnerId === FLEX_BENEFITS).map(p => partnerTileTemplate(p)).join('')
  )

  // Add click event listener to each partner tile
  externalPartners.forEach(partner => {
    const partnerTile = getById(`partner-tile-${partner.partnerId}`)
    if (partnerTile)
      partnerTile.addEventListener('click', () => getUrlAndRedirect(partner))
  })
}
